import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';

export default class AddDiscordWidget extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    this.discord = null;
  }

  oncreate(vnode) {
    super.oncreate(vnode);

    const channelId = app.forum.attribute('justoverclock-discord-widget.channelId');

    const fetchDiscord = fetch('https://discord.com/api/guilds/' + channelId + '/widget.json')
      .then((response) => response.json())
      .then((data) => {
        this.discord = data;

        const discordLink = this.discord.instant_invite;
        const linkEl = document.getElementById('discord-link');
        linkEl.setAttribute('href', discordLink);

        const presence = this.discord.presence_count;
        const onlineUsers = document.getElementById('online-users');
        onlineUsers.innerHTML = app.translator.trans('justoverclock-discord-widget.forum.onlineUsers') + presence;

        this.loading = false;
        m.redraw();
      });

    document.getElementById('openbtn').addEventListener('click', () => {
      const elem = document.getElementById('discord-widget');
      elem.setAttribute('class', 'chat-popup-open');
    });
    document.getElementById('close-popup').addEventListener('click', () => {
      const closeDiscord = document.getElementById('discord-widget');
      closeDiscord.setAttribute('class', 'chat-popup');
    });
  }

  view(vnode) {
    const discordLogo = app.forum.attribute('baseUrl') + '/assets/extensions/justoverclock-discord-widget/discord-logo.png';
    return (
      <div className="discord-widget">
        <div className="chat-popup" id="discord-widget">
          <div className="card discord">
            <button type="button" className="btn cancel" id="close-popup">
              {app.translator.trans('justoverclock-discord-widget.forum.close')} <i className="fas fa-window-close" />
            </button>
            <div className="discord-widget">
              <div className="discord-header">
                <div className="discord-logo-white">
                  <img className="logo-discord" src={discordLogo} alt="discord" />
                </div>
                <div id="members-count" />
              </div>
              <div className="discord-body">
                <div className="discord-list">
                  <div className="discord-list-status">
                    <div className="discord-list-label" id="online-users" />
                  </div>
                  <div id="discord-members">
                    {this.discord &&
                      this.discord.members &&
                      this.discord.members.map((member) => (
                        <div className="member-box">
                          <div className="container-img">
                            <img className="avatar-discord-img" src={member.avatar_url} />
                          </div>
                          <div className="container-username">{member.username}</div>
                          <div className="discord-status" id="discord-status" />
                        </div>
                      ))}
                  </div>
                </div>
                <div className="title-channel">
                  <h3 className="channel-title">
                    {app.translator.trans('justoverclock-discord-widget.forum.channels')}{' '}
                    <i className="fas fa-arrow-alt-circle-down discord-channel" />
                  </h3>
                </div>
                <div className="discord-list channels" id="discord-channels">
                  {this.discord &&
                    this.discord.channels &&
                    this.discord.channels.map((channel) => (
                      <div className="channel-name">
                        <div className="container-img channels">
                          <i className="fab fa-discord" />
                        </div>
                        <div className="channel-name">{channel.name}</div>
                      </div>
                    ))}
                </div>
                <a id="discord-link" target="_blank" rel="nofollow">
                  <button className="discord-cta">
                    {app.translator.trans('justoverclock-discord-widget.forum.joinUs')}
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
        <button className="open-button" id="openbtn">
          <i className="fab fa-discord fa-pulse" />
        </button>
      </div>
    );
  }
}
